module.exports = __webpack_public_path__ + "static/img/chrome.3deb0251.png";